import { useRef } from "react"
import styled, { useTheme } from "styled-components"
import { CheckBox } from "~/components/Checkbox"
import { Label } from "~/components/Label"
import { Icon } from "~/ur-react-components"
import { useClickOutside } from "~/ur-react-hooks"

const Layout = styled.div`
  margin-left: 8px;
  display: inline;

  position: relative;
`

interface SubMenuProps {
  open: boolean
}

const SubMenu = styled.div<SubMenuProps>`
  position: absolute;
  top: 2rem;
  right: -80px;
  display: ${(props) => (props.open ? "block" : "none")};

  box-shadow: ${(props) => props.theme.shadow.elevation3};
  border-radius: 8px;

  background: white;
`

interface SubMenuItemProps {
  checked: boolean
}

const SubMenuListItem = styled.label<SubMenuItemProps>`
  cursor: pointer;
  width: 100%;
  padding: 1rem;
  height: 52px;
  width: 200px;
  box-sizing: border-box;

  display: flex;
  align-items: center;
  gap: 0.5rem;

  label {
    color: ${(props) =>
      props.checked
        ? props.theme.colors.primary50
        : props.theme.colors.gray40} !important;
  }
`

export interface TableHeaderFilterProps {
  open: boolean
  onClose: () => void
  onFilterChanged: (newValue: any[]) => void
  values: { value: any; label: string }[]
  activeFilters: any[]
}

export const TableHeaderFilter: React.FC<TableHeaderFilterProps> = ({
  open,
  onClose,
  values,
  activeFilters,
  onFilterChanged,
}) => {
  const ref = useRef<HTMLDivElement>(null)
  useClickOutside(ref, (e) => {
    // This can happen if we click the TableHeaderCell in the QuoTable, but still
    // outside of this element. If so, the close is already handled, and we ignore this.
    if (e.target === ref.current?.parentElement) {
      return
    }

    e.stopPropagation()
    onClose()
  })
  const theme = useTheme()
  return (
    <Layout ref={ref}>
      <Icon icon="filter-list" size="16px" />
      <SubMenu open={open} onClick={(e) => e.stopPropagation()}>
        {values.map((value) => {
          const checked = activeFilters.includes(value.value)
          return (
            <SubMenuListItem checked={checked}>
              <CheckBox
                boxSize="16px"
                checked={checked}
                boxColor={theme.colors.primary50}
                onChange={(checked) => {
                  const newFilter = checked
                    ? [...activeFilters, value.value]
                    : activeFilters.filter((v) => v !== value.value)
                  onFilterChanged(newFilter)
                }}
              />
              {value.label}
            </SubMenuListItem>
          )
        })}
      </SubMenu>
    </Layout>
  )
}
